// extracted by mini-css-extract-plugin
module.exports = {"labelText":"TargetStatus--labelText--11Jnh","valueText":"TargetStatus--valueText--1eOO7"};